var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowInsert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_insert"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_193_396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 36,
    height: 36,
    transform: "matrix(-1 0 0 1 36 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_193_396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_insert_2",
    d: "M24.2169 11.7057V24C24.2169 24.3187 24.3247 24.5859 24.5404 24.8015C24.7561 25.0171 25.0234 25.1249 25.3423 25.1249C25.6612 25.1249 25.9284 25.0171 26.1437 24.8015C26.3591 24.5859 26.4668 24.3187 26.4668 24V9.23074C26.4668 8.84661 26.3369 8.52463 26.077 8.26478C25.8172 8.00493 25.4952 7.875 25.1111 7.875H10.3418C10.0231 7.875 9.7559 7.98285 9.54027 8.19855C9.32467 8.41428 9.21687 8.68158 9.21687 9.00045C9.21687 9.31935 9.32467 9.58649 9.54027 9.80186C9.7559 10.0172 10.0231 10.1249 10.3418 10.1249H22.6361L8.65148 24.124C8.44378 24.3317 8.34233 24.5928 8.34713 24.9072C8.35196 25.2216 8.45821 25.4826 8.66589 25.6903C8.87358 25.898 9.13223 26.0019 9.44183 26.0019C9.75143 26.0019 10.0101 25.898 10.2178 25.6903L24.2169 11.7057Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInsert);
export default __webpack_public_path__ + "static/media/arrow_insert.5474ad37f539e0e9dd5346e6be7acdc2.svg";
export { ForwardRef as ReactComponent };